import { render, staticRenderFns } from "./github-extra-actions.vue?vue&type=template&id=1eb11596&scoped=true"
import script from "./github-extra-actions.vue?vue&type=script&lang=js"
export * from "./github-extra-actions.vue?vue&type=script&lang=js"
import style0 from "./github-extra-actions.vue?vue&type=style&index=0&id=1eb11596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb11596",
  null
  
)

export default component.exports